/**
 * LLMNotConfigured — BYOK-strict empty state.
 *
 * Rendered wherever a model dropdown or agent-creation button would appear
 * when the tenant has no provider key configured.
 *
 * Props:
 *   variant: "banner" (full-width across dashboard) | "inline" (compact in dropdown)
 *   onConfigure: optional callback (default: navigate to Admin → LLM Settings)
 */

import React from "react";
import { useNavigate } from "react-router-dom";

export function LLMNotConfigured({ variant = "banner", onConfigure, message }) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onConfigure) return onConfigure();
    // Deep-link to Admin LLM Settings. AdminView reads a URL query param.
    navigate("/admin?tab=integrations&section=llm");
  };

  const defaultMessage =
    "No LLM provider configured. The platform can't generate responses, " +
    "create agents, or run smart routing until at least one provider API key " +
    "and one model ranking are set.";

  if (variant === "inline") {
    return (
      <div
        style={{
          padding: "8px 12px",
          background: "#FEF3C7",
          border: "1px solid #F59E0B",
          borderRadius: 6,
          fontSize: 13,
          color: "#92400E",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span>{message || "No models available — configure an LLM provider first."}</span>
        <button
          onClick={handleClick}
          style={{
            background: "#F59E0B",
            color: "white",
            border: "none",
            padding: "4px 10px",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          Configure
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: 16,
        background: "linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)",
        border: "1px solid #F59E0B",
        borderRadius: 10,
        marginBottom: 16,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
      }}
      role="alert"
    >
      <div>
        <div style={{ fontWeight: 700, fontSize: 15, color: "#78350F", marginBottom: 4 }}>
          LLM provider not configured
        </div>
        <div style={{ fontSize: 13, color: "#92400E" }}>
          {message || defaultMessage}
        </div>
      </div>
      <button
        onClick={handleClick}
        style={{
          background: "#D97706",
          color: "white",
          border: "none",
          padding: "8px 16px",
          borderRadius: 6,
          cursor: "pointer",
          fontSize: 13,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        Go to LLM Settings →
      </button>
    </div>
  );
}

export default LLMNotConfigured;
